var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"train-s",class:[
    _vm.pos.length > 3 ? (_vm.train.ki ? 'down-box' : 'up-box') : '',
    ("ODPT" + (_vm.train.tr))
  ]},[_c('Train',{attrs:{"tr":_vm.train.tr,"ik":_vm.ik,"sy":_vm.train.sy,"ki":_vm.train.ki,"unyo":_vm.unyo,"vehicle":_vm.vehicle,"bg-style":_vm.style,"line":"S"}}),(_vm.train.dl)?_c('div',{staticClass:"delay",style:({
      order: _vm.train.ki ? -1 : 1
    })},[_vm._v(" + "+_vm._s(_vm.train.dl / 60)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }